// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/stalls-spins.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/stalls-spins/stalls-spins.js';

mount([g0]);
